import { routes } from '../../App/constants/routes';

export const sections = [
  { title: 'Начать обучение', path: routes.learn, svgClass: 1 },
  { title: 'Мини-игра Аудиовызов', path: routes.audioCall, svgClass: 2 },
  { title: 'Мини-игра Квиз', path: routes.quiz, svgClass: 5 },
  { title: 'Мини-игра Саванна', path: routes.savanna, svgClass: 3 },
  { title: 'Мини-игра Спик Ит', path: routes.speakIt, svgClass: 4 },
  { title: 'Мини-игра Спринт', path: routes.sprint, svgClass: 5 },
  { title: 'Мини-игра Пазл', path: routes.englishPuzzle, svgClass: 3 },
];
